(function() {

    "use strict";

    /**
     * Converts segment multidimensional segment arrays to flat array of lines.
     *
     *     var converter = new Ofcs.SegmentsToLinesConverter();
     *
     * @constructor
     */
    Ofcs.SegmentsToLinesConverter = function() {
        // nothing to do in constructor
    };

    Ofcs.SegmentsToLinesConverter.prototype = {

        /**
         * @param {Array} segments multidimensional array
         *
         * @returns {Array|Ofcs.Line[]} flat array of line objects
         */
        convert: function(segments) {
            var lines = [], i, j;

            for (i = 0; i < segments.length; i += 1) {
                this._assertFirstSegmentIsMove(segments[i]);

                for (j = 1; j < segments[i].length; j += 1) {
                    this._assertSegmentIsLine(segments[i][j]);

                    lines.push(
                        this._createLine(segments[i][j - 1], segments[i][j])
                    );
                }
            }

            return lines;
        },

        /**
         * Assert that first subsegment is a move 'M'.
         *
         * @param {Array} subsegments
         */
        _assertFirstSegmentIsMove: function (subsegments) {
            if (subsegments.length) {
                this.assertSegmentIsMove(subsegments[0]);
            }
        },

        /**
         * Assert that segment is a line 'L'.
         *
         * @param {Array} segment
         */
        _assertSegmentIsLine: function (segment) {
            if (segment.length && segment[0] !== 'L') {
                throw 'Expecting line ("L"), found: "' + segment[0] + '"';
            }
        },

        /**
         * Assert that segment is a move 'M'.
         *
         * @param {Array} segment
         */
        assertSegmentIsMove: function (segment) {
            if (segment.length && segment[0] !== 'M') {
                throw 'Expecting move ("M"), found: "' + segment[0] + '"';
            }
        },

        /**
         * Create a line of two segments.
         *
         * @param {Array} firstSegment
         * @param {Array} secondSegment
         *
         * @returns {Ofcs.Line}
         */
        _createLine: function (firstSegment, secondSegment) {
            return new Ofcs.Line(
                new Ofcs.Point(firstSegment[1], firstSegment[2]),
                new Ofcs.Point(secondSegment[1], secondSegment[2])
            );
        }

    };

}());
